import Error from 'error';

export default class CustomError extends Error {
  constructor(message) {
    super(message);
    this.isCustom = true;
  }
};

export class ValidationError extends CustomError {};